import { Component, OnInit } from '@angular/core';
import { SessionData } from '@core/models/auth.model';
import { StoreService } from '@core/store/store.service';
import { TranslateService } from '@ngx-translate/core';
import { StepDirective } from '../../models/step';
import { ActivatedRoute } from '@angular/router';
import { AccountSelectionComponent } from '@shared/components/account-selection/account-selection.component';

@Component({
  selector: 'app-cfs-secure-sign-in',
  templateUrl: './cfs-secure-sign-in.component.html',
  styleUrls: ['./cfs-secure-sign-in.component.scss'],
  imports: [AccountSelectionComponent]
})
export class CfsSecureSignInComponent extends StepDirective implements OnInit {

  static key = 'CfsSecureSignInComponent';

  public session: SessionData;
  public message: string;
  headerTitle: string;
  sub_header: string;

  constructor(
    private translate: TranslateService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { super(); }

  ngOnInit() {
    this.session = this.store.getSession();
    const token = this.activatedRoute.snapshot.params['token'];
    this.message = token ? 'REGISTRATION_PAGE.stepperSection.cfsSecureSignIn1' : 'REGISTRATION_PAGE.authAccountSelection.placeHolderText';

    if(this.inputData === 'ORG') {
      this.headerTitle = 'REGISTRATION_PAGE.stepperSection.orgTitleFinalStep';
    } else {
      this.headerTitle = 'REGISTRATION_PAGE.stepperSection.vbTitleFinalStep';
    }
  }

}
